/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EqualIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "equal", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M7.5 4.5H3.5V20.5H7.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17.5 20.5L21.5 20.5L21.5 4.5L17.5 4.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9 10.5H16", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9 14.5H16", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(EqualIcon);
export default ForwardRef;
//# sourceMappingURL=equalIcon.js.map